import { data } from '../../svg/CalendarToday/data';
import { makeIcon } from '../makeIcon';

export const CalendarToday = makeIcon(data, 'calendar_today', 'CalendarToday');

export default CalendarToday;
